module.exports = __webpack_public_path__ + "b3d9ae7a25e866ac949490f304a17046.svg";